import { put, takeEvery } from 'redux-saga/effects';
import { Content } from '~/interfaces/Content';
import { fetchContent } from '../services/contentServices';
import { CONTENT_REQUESTED, contentLoaded, ContentRequested } from './App.actions';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function* fetchContentSaga(action: ContentRequested): any {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const data: Partial<Content> = yield fetchContent(action.locale);
  yield put(contentLoaded(data));
}

function* appSaga() {
  yield takeEvery(CONTENT_REQUESTED, fetchContentSaga);
}

export default appSaga;
